export const LIST_SCROLL_PREFIX = 'listScroll:';

export function readJsonStorage(storage, key, fallback) {
    if (!key || !storage) {
        return fallback;
    }
    try {
        const raw = storage.getItem(key);
        if (raw == null) {
            return fallback;
        }
        return JSON.parse(raw);
    } catch {
        return fallback;
    }
}

export function writeJsonStorage(storage, key, value) {
    if (!key || !storage) {
        return;
    }
    try {
        storage.setItem(key, JSON.stringify(value));
    } catch {
        // Private mode / quota — best effort
    }
}

export function scrollStorageKey({ id, pathname = '', displayMode = 'default' }) {
    return `${LIST_SCROLL_PREFIX}${id}:${pathname}:${displayMode || 'default'}`;
}

export function readListScroll(key) {
    const saved = readJsonStorage(sessionStorage, key, null);
    if (!saved || typeof saved !== 'object') {
        return { scrollOffset: 0, fetchOffset: 0 };
    }
    const scrollOffset = Number(saved.scrollOffset);
    const fetchOffset = Number(saved.fetchOffset);
    return {
        scrollOffset: Number.isFinite(scrollOffset) && scrollOffset > 0 ? scrollOffset : 0,
        fetchOffset: Number.isFinite(fetchOffset) && fetchOffset > 0 ? fetchOffset : 0,
    };
}

export function writeListScroll(key, { scrollOffset = 0, fetchOffset } = {}) {
    const payload = {
        scrollOffset: Math.max(0, Number(scrollOffset) || 0),
    };
    if (fetchOffset != null && Number.isFinite(Number(fetchOffset))) {
        payload.fetchOffset = Math.max(0, Number(fetchOffset));
    }
    writeJsonStorage(sessionStorage, key, payload);
}

export function clearListScroll(key) {
    try {
        sessionStorage.removeItem(key);
    } catch {
        // best effort
    }
}

export function clearAllListScroll() {
    try {
        const keys = [];
        for (let index = 0; index < sessionStorage.length; index += 1) {
            const key = sessionStorage.key(index);
            if (key && key.startsWith(LIST_SCROLL_PREFIX)) {
                keys.push(key);
            }
        }
        keys.forEach((key) => sessionStorage.removeItem(key));
    } catch {
        // best effort
    }
}

export function offsetFromScroll({ scrollOffset = 0, itemSize, columns = 1 }) {
    if (!itemSize || itemSize <= 0) {
        return 0;
    }
    const row = Math.floor(Math.max(0, scrollOffset) / itemSize);
    return Math.max(0, row * Math.max(1, columns));
}

export function peekListFetchOffset({
    id,
    pathname = '',
    displayMode = 'default',
    itemSize,
    columns = 1,
}) {
    const saved = readListScroll(scrollStorageKey({ id, pathname, displayMode }));
    if (saved.fetchOffset > 0) {
        return saved.fetchOffset;
    }
    return offsetFromScroll({
        scrollOffset: saved.scrollOffset,
        itemSize,
        columns,
    });
}
